import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home/index.vue'
import Login from '../views/Login/index.vue'
import User from '../views/UserCenter/index.vue'
import ActiveInfo from '../views/ActiveInfo/index.vue'
import Register from '../views/Register/index.vue'
import Sign from '../views/Sign/index.vue'
import Scancode from '../views/Scancode/index.vue'
import Myactive from '../views/Myactive/index.vue'
import UserInfo from '../views/UserCenter/components/edit.vue'
import Protocol from '../views/Protocol/index.vue'
import Policy from '../views/Protocol/policy.vue'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: '首页'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: '登录'
  },
  {
    path: '/user',
    name: 'User',
    component: User,
    meta: '个人中心'
  },
  {
    path: '/activeinfo',
    name: 'ActiveInfo',
    component: ActiveInfo,
    meta: '活动通知'
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
    meta: '立即报名'
  },
  {
    path: '/sign',
    name: 'Sign',
    component: Sign,
    meta: '签到二维码'
  },
  {
    path: '/scancode',
    name: 'Scancode',
    component: Scancode,
    meta: '扫码签到'
  },
  {
    path: '/myactive',
    name: 'Myactive',
    component: Myactive,
    meta: '我的活动'
  },
  {
    path: '/userinfo',
    name: 'UserInfo',
    component: UserInfo,
    meta: '基本信息'
  },
  {
    path: '/protocol',
    name: 'Protocol',
    component: Protocol,
    meta: '用户协议'
  },
  {
    path: '/policy',
    name: 'Policy',
    component: Policy,
    meta: '隐私政策'
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

import { setDocumentTitle } from '../utils/document-title-util'
import { getToken } from '../utils/token-util';

router.beforeEach((to, from, next) => {
  setDocumentTitle(to.meta);

  if (to.path === "/login") return next();

  const path = ['/', '/activeinfo', '/scancode', '/protocol','/policy'];
  const token = getToken();

  if (!path.includes(to.path)) {
    if (!token) return next('/login');
  }
  next();
});

export default router
